import { render, staticRenderFns } from "./TabRepresentantesYApoderados.vue?vue&type=template&id=4548d653&scoped=true"
import script from "./TabRepresentantesYApoderados.vue?vue&type=script&lang=js"
export * from "./TabRepresentantesYApoderados.vue?vue&type=script&lang=js"
import style0 from "./TabRepresentantesYApoderados.vue?vue&type=style&index=0&id=4548d653&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548d653",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4548d653')) {
      api.createRecord('4548d653', component.options)
    } else {
      api.reload('4548d653', component.options)
    }
    module.hot.accept("./TabRepresentantesYApoderados.vue?vue&type=template&id=4548d653&scoped=true", function () {
      api.rerender('4548d653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabRepresentantesYApoderados.vue"
export default component.exports